"use strict";

var rawEncode = require("ethereumjs-abi").rawEncode;

function abiEncodeInt256(value) {
  return rawEncode(["int256"], [value]).toString("hex");
}

module.exports = abiEncodeInt256;



//////////////////
// WEBPACK FOOTER
// ./node_modules/speedomatic/src/abi-encode-int256.js
// module id = 505
// module chunks = 146